<template>
  <b-modal v-model="showModal" @hide="$emit('close')" size="md">
    <template #modal-header>
      <h5 class="modal-title">{{ $t('simple.forward_crm_conditions_title', { account_name: account.name }) }}</h5>
      <b-button variant="outline-danger" size="sm" @click="closeModal">&times;</b-button>
    </template>

    <b-form-group>
      <!-- Incoming messages checkbox -->
      <div class="d-flex align-items-center mb-3">
        <b-form-checkbox v-model="forwardIncoming" class="mb-0">
          {{ $t('simple.forward_incoming_label') }}
        </b-form-checkbox>
        <font-awesome-icon
          :icon="'info-circle'"
          class="ml-2 text-info crm-info-icon"
          v-b-popover.hover.click.right="{
            content: $t('simple.forward_incoming_popover'),
            title: $t('simple.forward_incoming_popover_title'),
          }"
        />
      </div>

      <!-- Outgoing messages checkbox -->
      <div class="d-flex align-items-center">
        <b-form-checkbox v-model="forwardOutgoing" class="mb-0">
          {{ $t('simple.forward_outgoing_label') }}
        </b-form-checkbox>
        <font-awesome-icon
          :icon="'info-circle'"
          class="ml-2 text-info crm-info-icon"
          v-b-popover.hover.click.right="{
            content: $t('simple.forward_outgoing_popover'),
            title: $t('simple.forward_outgoing_popover_title'),
          }"
        />
      </div>
    </b-form-group>

    <template #modal-footer>
      <b-button variant="primary" @click="saveConditions">{{ $t('default.save') }}</b-button>
      <b-button variant="secondary" @click="closeModal">{{ $t('default.cancel') }}</b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'forward-crm-conditions',
  props: {
    account: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      showModal:       true,
      forwardIncoming: this.account.automation?.forward_incoming_crm ?? false,
      forwardOutgoing: this.account.automation?.forward_outgoing_crm ?? false,
    };
  },

  methods: {
    saveConditions() {
      this.$emit('save', {
        accountId:       this.account.id,
        forwardIncoming: this.forwardIncoming,
        forwardOutgoing: this.forwardOutgoing,
      });
      this.closeModal();
    },

    closeModal() {
      this.showModal = false;
      this.$emit('close');
    },
  },
};
</script>
